import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Barcode from 'react-barcode';
import Grid from '@material-ui/core/Grid';
import combineStyles from '../../utils/combineStyles';
import { withStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import TypographyStyles from '../../styles/typography';
import LayoutStyles from '../../styles/layout';
import SpacingStyles from '../../styles/helpers/spacing';
import LabelsStyles from './__styles__/Labels.styles';

class LabelBarcode extends Component {
  static propTypes = {
    proNumber: PropTypes.string.isRequired
  };
  render() {
    const { proNumber, classes, t } = this.props;
    const proNumText = `${t('PRO')}# ${proNumber}`;

    // figure out column padding for the pro number.  The barcode
    // is a variable length and doesn't respond well to CSS centering
    // for some reason so this is a quick and dirty way to make it
    // look better.  //TODO - revisit at a later time
    let colPadding = 2;
    if (proNumber && proNumber.length > 8) {
      colPadding = 1;
    }

    return (
      <Grid container spacing={16}>
        <Grid item xs={colPadding} />
        <Grid
          item
          xs={4}
          className={classnames(classes.labelFont, classes.barcodeMargin)}
        >
          <Barcode
            value={proNumber}
            text={proNumText}
            height={60}
            width={3}
            fontSize={30}
          />
        </Grid>
      </Grid>
    );
  }
}

const translatedLabelBarcode = withNamespaces()(LabelBarcode);
export default withStyles(
  combineStyles(LabelsStyles, TypographyStyles, LayoutStyles, SpacingStyles)
)(translatedLabelBarcode);
